import { Button } from 'antd';
import { useCallback, useState } from 'react';
import ConfirmResetModal from './confirm.reset';
import apiCalls from 'src/api/apiCalls';
import { isErrorMessage } from 'src/components/shared/error.message';
const ResetAuthenticator = ({ getResetTwoFa }) => {
    const [twofaErrorMessage, setTwofaErrorMessage] = useState(null);
    const [resetModalOpen, setResetModalOpen] = useState(false);
    const [profileBtnLoader, setProfileBtnLoader] = useState(false);
    const handleResetModalClose = useCallback(() => {
        setResetModalOpen(false);
    }, [])
    const handleConfirmReset = useCallback(async () => {
        setTwofaErrorMessage(null);
        setProfileBtnLoader(true);
        try {
            let response = await apiCalls.resetAuthenticator();
            if (response) {
                setTwofaErrorMessage(null);
                getResetTwoFa();
                handleResetModalClose();
                await setTwoFa();
            } else {
                setTwofaErrorMessage(isErrorMessage(response?.data));
                window.scroll(0, 0);
            }
        } catch (error) {
            setTwofaErrorMessage(error);
            window.scroll(0, 0);
        } finally {
            setProfileBtnLoader(false);
        }
    }, [getResetTwoFa, handleResetModalClose]);
    const setTwoFa = useCallback(async () => {
        try {
            let response = await apiCalls.setTwoFaEnable(false);
            if (response) {
                setTwofaErrorMessage(null);
            } else {
                window.scroll(0, 0);
                setTwofaErrorMessage(isErrorMessage(response?.data))
            }
        } catch (error) {
            setTwofaErrorMessage(error);
            window.scroll(0, 0);
        } finally {
            setProfileBtnLoader(false);
        }
    }, []);
    const handleResetModalOpen = useCallback(() => {
        setResetModalOpen(true);
    }, [])
    const closeError = useCallback(() => {
        setTwofaErrorMessage(null);
    }, [])
    return (
        <>
            <div className='border border-StrokeColor rounded-5 mt-4 p-3.5'>
                <h4 className='text-lg font-semibold text-darkWhite text-center'>Reset authenticator</h4>
                <p className='text-paraColor text-sm font-normal text-center'>
                    If you would like to change your authenticator app, you can reset it here.
                </p>
                <div className='mt-4 text-center'>
                    <Button className='primary-btn' type="primary" htmlType="submit" onClick={handleResetModalOpen}>
                        Reset authenticator
                    </Button>
                </div>
            </div>
            {resetModalOpen && <ConfirmResetModal resetModalOpen={resetModalOpen} handleResetModalClose={handleResetModalClose} handleConfirmReset={handleConfirmReset}
                errorMessage={twofaErrorMessage} closeError={closeError} buttonLoader={profileBtnLoader} />}
        </>
    );
};
export default ResetAuthenticator;
